import React from "react";
import clsx from "clsx";

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  helperText?: string;
  allowDecimal?: boolean;
  dataTestId?: string;
  className?: string;
  icon?: boolean;
  imageName?: string;
  iconOnClick?: () => void;
}

// FIXME: remove w-full
const BASE_STYLES =
  "border border-input-border font-medium rounded-lg text-text-primary placeholder:text-label-muted outline-none bg-input-bg text-[16px] py-[10px] px-4 w-full h-[40px] focus:border-indigo-400/40 focus:ring-1 focus:ring-indigo-400/20 transition-all duration-200";

const CustomInput = React.forwardRef<HTMLInputElement, InputProps>(
  (
    {
      label,
      id,
      error,
      disabled,
      helperText,
      className,
      allowDecimal,
      dataTestId,
      icon,
      imageName,
      iconOnClick,
      ...props
    }: InputProps,
    ref
  ) => {
    const allowStep = allowDecimal && props.type === "number";

    return (
      <div className="space-y-1 w-full">
        {label ? (
          <label
            className="block text-[13px] font-medium text-light-gray"
            data-testid="input-label"
            htmlFor={id}
          >
            {label}
          </label>
        ) : null}
        <input
          {...props}
          data-testid={dataTestId}
          aria-invalid={!!error}
          disabled={disabled}
          aria-disabled={disabled}
          id={id}
          step={allowStep ? "0.001" : undefined}
          ref={ref}
          className={clsx(
            BASE_STYLES,

            className,
            error && "border-ilara-red"
          )}
        />
        {icon ? (
          <img
            src={imageName}
            className="w-4 h-4 absolute top-0 !mt-8 mr-8 flex justify-center items-center right-0 cursor-pointer"
            alt=""
            onClick={iconOnClick}
          />
        ) : null}
        {error || helperText ? (
          <p
            className={`${error ? "text-ilara-red" : "text-ilara-secondary-text"
              } text-xs font-medium`}
            data-testid={error ? "input-error" : "input-helper-text"}
          >
            {error || helperText}
          </p>
        ) : null}
      </div>
    );
  }
);

export default CustomInput;
